import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DocumentsAGNotesReportContextService } from '@app/core/services/context/factory';
import { ShellService } from '@mynexus/mfe-core';
import { Observable } from 'rxjs';

@Injectable()
export class SharedDocumentsAGNotesReportService implements DocumentsAGNotesReportContextService {

  protected readonly API_URL;

  constructor(
    protected http: HttpClient,
    protected shellService: ShellService,
    @Inject('stream') private readonly stream: string
  ) {
    this.API_URL = shellService.getBaseUrlFor(stream);
  }
  
  getInformationMessage(): string {
    return 'Please select the Service Line(s) to generate the A&G Notes Report';
  }

  downloadAGNotes(tenantId: string, authorizationByProductId: string, lineIds: object[]): Observable<string> {
    return this.http.post(`${this.getBaseUrl(tenantId, authorizationByProductId)}/DownloadAGNotes`, lineIds, { responseType:'text' });
  }

  //Protected Methods
  protected getBaseUrl(tenantId: string, id: string): string {
    return `${this.API_URL}/tenants/${tenantId}/authorizations/${id}/Documents`;
  }
}
